import { render } from "./Votes.vue?vue&type=template&id=7a7c0f64"
import script from "./Votes.vue?vue&type=script&lang=ts"
export * from "./Votes.vue?vue&type=script&lang=ts"
script.render = render

export default script